export class Permission {
  available: boolean;
  withAction: boolean;
  constructor() {
    this.available = false;
    this.withAction = false;
  }
}
